module.exports = __webpack_public_path__ + "static/media/1-what-is-irritable-bowel-syndrome@3x.acc7d0be.jpg";